import { Route } from '@angular/router';
import { featureToggleGuard } from '@core/guards/feature-toggle-guard.guard';
import { environment } from '@environment/environment';
import { CasesMonitoredComponent } from './components/cases-monitored/cases-monitored.component';
import { CreateExamComponent } from './components/create-exam/create-exam.component';
import { ExamListComponent } from './components/exam-list/exam-list.component';
import { ImageDatabaseComponent } from './components/image-database/image-database.component';
import { IntegrationLogComponent } from './components/integration-log/integration-log.component';
import { OpenedDiscussionsComponent } from './components/opened-discussions/opened-discussions.component';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { MainPageComponent } from './main-page.component';
const useGuard = environment.enableRouteGuards;

export const MAIN_PAGE_ROUTES: Route[] = [
  {
    path: '',
    component: MainPageComponent,
    children: [
      { path: '', component: ExamListComponent },
      { path: 'database', component: ImageDatabaseComponent },
      { path: 'user_management', component: UserManagementComponent },
    ],
  },
];

if (environment.enableDiscussion) {
  MAIN_PAGE_ROUTES[0].children?.push({
    path: 'discussion',
    component: OpenedDiscussionsComponent,
    canMatch: [featureToggleGuard(useGuard ? 'enableDiscussion' : null, '')],
  });
}

if (environment.enableRegisterCase) {
  MAIN_PAGE_ROUTES[0].children?.push({
    path: 'create_exam',
    component: CreateExamComponent,
    canMatch: [featureToggleGuard(useGuard ? 'enableRegisterCase' : null, '')],
  });
  MAIN_PAGE_ROUTES[0].children?.push({
    path: 'create_exam/:id',
    component: CreateExamComponent,
    canMatch: [featureToggleGuard(useGuard ? 'enableRegisterCase' : null, '')],
  });
}

if (environment.enableIntegrationLog) {
  MAIN_PAGE_ROUTES[0].children?.push({
    path: 'integration_log',
    component: IntegrationLogComponent,
  });
}

MAIN_PAGE_ROUTES[0].children?.push({
  path: 'monitor_case',
  component: CasesMonitoredComponent,
});
